import React, { useMemo, useRef } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'
import * as THREE from "three"
import model from "../../../Assets/Carpet/carpet.glb"
import normTex from "../../../Assets/Carpet/normal.jpg"
import tex from "../../../Assets/Carpet/tex.jpg"

export default function Model({size}) {
  const group = useRef()

  const [map, normalMap] = useTexture([tex, normTex])
  map.flipY = false

  normalMap.wrapS = normalMap.wrapT = THREE.RepeatWrapping
  map.wrapS = map.wrapT = THREE.RepeatWrapping
  map.repeat.set(10, 50)

  normalMap.wrapS = normalMap.wrapT = THREE.RepeatWrapping
  normalMap.repeat.set(10, 50)

  const carpetMaterial = useMemo(() => {
    return new THREE.MeshPhongMaterial({
      color : "#0d340d",
      map : map,
      normalMap : normalMap
    }) 
  }, [])

  const { nodes, materials } = useGLTF(model)
  return (
    <group ref={group} scale={[3,3,15]} position={[-(size+40)/2, 0, 0]} dispose={null}>
      <group position={[0, 0, 0]} rotation={[Math.PI / 2, 0, 0]} scale={[0.01, 0.01, 0.01]}>
        <mesh 
          geometry={nodes.Carpet_1.geometry} 
          material={carpetMaterial} 
        />
      </group>
    </group>
  )
}

useGLTF.preload(model)
